import i18n from "@/i18n"
import { getBalance, getUserData } from "@/services/userService"
import { parseUrl } from "@/utils/cdn"
import getPriceWithCurrency from "@/utils/getPriceWithCurrency"

import { LOGOUT } from "../auth/actionTypes"

import { GET_BALANCE, GET_USER_DATA } from "./actionTypes"
import { SET_BALANCE, SET_USER_DATA } from "./mutationTypes"

const state = () => ({
  profile: {},
  user: {},
  commissionBalance: {
    balance: 0,
    leftover: 0,
    on_hold: 0
  }
})

const getters = {
  smallShopLogoAbsolutePath: (state) => {
    const hasProfile = Object.keys(state.profile).length > 0

    if (hasProfile) {
      const cdnUrl = new URL(process.env.VUE_APP_CDN_URL).origin
      const logoPath = parseUrl(state.profile.small_logo, "full")

      return `${cdnUrl}/media/assets/images/${logoPath}`
    } else {
      return ""
    }
  },

  notification(state) {
    const isSellerActive = "is_active" in state.profile ? state.profile.is_active : true
    const isOffersVisible = state.profile.offers_visibility !== "HIDDEN"
    const isLeftoverNegative = state.commissionBalance && state.commissionBalance.leftover < 0

    if (!isSellerActive) {
      return {
        text: i18n.t("dashboard.offers_and_seller_page_blocked"),
        type: "alert"
      }
    } else if (isSellerActive && !isOffersVisible) {
      return {
        text: i18n.t("dashboard.sales_suspended"),
        type: "alert"
      }
    } else if (isLeftoverNegative) {
      return {
        text: i18n.t("dashboard.negative_balance_alert", {
          balance: getPriceWithCurrency(state.commissionBalance.leftover)
        }),
        type: "alert",
        button: "topUp"
      }
    }

    return {}
  }
}

const mutations = {
  [SET_USER_DATA]: (state, payload) => {
    state.profile = payload ? payload.profile : {}
    state.user = payload ? payload.user : {}
  },
  [SET_BALANCE]: (state, payload) => {
    state.commissionBalance = payload.commissionBalance ? payload.commissionBalance : {}
  }
}

const actions = {
  [GET_USER_DATA]: async ({ commit, dispatch }) => {
    dispatch(GET_BALANCE)

    try {
      const [profile, user] = await getUserData()

      commit(SET_USER_DATA, {
        profile: profile.data,
        user: user.data
      })

      return Promise.resolve([profile, user])
    } catch (err) {
      dispatch(`auth/${LOGOUT}`, null, { root: true })

      throw Error(err)
    } finally {
    }
  },
  [GET_BALANCE]: async ({ commit }) => {
    try {
      const { data } = await getBalance()

      commit(SET_BALANCE, {
        commissionBalance: data
      })

      return data
    } catch (e) {
      return new Error(e)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
